import { citySearchHistory } from 'shared';

import { googleAnalyticsEventsLib } from '../google-analytics-events';
import { amplitudeEventsLib } from '../amplitude-events';
import { jsBridgeEventsLib } from '../js-bridge';
import { bloomreachEventsLib } from '../bloomreach-events';
import type { DetailsPageOpenParams, JjDetailsBannerShowParams } from './types';

export const detailsPageOpen = (params: DetailsPageOpenParams) => {
  const searchHistory =
    citySearchHistory.model.useCitySearchHistory('free-avia');
  const locations = searchHistory.getCities();

  googleAnalyticsEventsLib.detailsPageOpen();
  amplitudeEventsLib.detailsPageOpen(params, locations);
  jsBridgeEventsLib.offerDetailViewed(params, locations);
  bloomreachEventsLib.offerPriceClick(params);
};

export const detailsPageContinue = (params: DetailsPageOpenParams) => {
  const searchHistory =
    citySearchHistory.model.useCitySearchHistory('free-avia');
  const locations = searchHistory.getCities();

  googleAnalyticsEventsLib.detailsPageContinue();
  amplitudeEventsLib.detailsPageContinue(params, locations);
  jsBridgeEventsLib.tariffButtonClicked();
};

export const jjDetailsBannerShow = (params: JjDetailsBannerShowParams) => {
  amplitudeEventsLib.jjDetailsBannerShow(params);
};
